import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Plug, Globe, Mail as MailIcon, GitBranch, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

import IntegrationsPage from "@/pages/IntegrationsPage";
import WebsiteCheckSettings from "@/components/sales/WebsiteCheckSettings";
import PipelineSettings from "@/components/sales/PipelineSettings";
import EmailTemplatesSettings from "@/components/sales/EmailTemplatesSettings";

const TABS = [
  { k: "integrations",  l: "Integrationen",   icon: Plug,    component: IntegrationsPage },
  { k: "website_check", l: "Website-Check",   icon: Globe,   component: WebsiteCheckSettings },
  { k: "pipeline",      l: "Pipeline-Stages", icon: GitBranch, component: PipelineSettings },
  { k: "templates",     l: "E-Mail-Vorlagen", icon: MailIcon, component: EmailTemplatesSettings },
];

export default function SettingsPage() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialTab = searchParams.get("tab") || "integrations";
  const [tab, setTab] = useState(TABS.find(t => t.k === initialTab) ? initialTab : "integrations");

  // Redirect if not admin
  useEffect(() => {
    if (user && user.role !== "admin") navigate("/dashboard");
  }, [user, navigate]);

  const setTabAndUrl = (newTab) => {
    setTab(newTab);
    setSearchParams({ tab: newTab });
  };

  const ActiveComponent = TABS.find(t => t.k === tab)?.component;

  return (
    <div className="max-w-6xl mx-auto" data-testid="settings-page">
      <div className="mb-6">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground mb-1">
          <ShieldCheck size={12} /> Admin-Bereich
        </div>
        <h1 className="text-3xl font-bold text-foreground">Einstellungen</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Zentrale Konfiguration für Integrationen, Website-Check, Pipeline und E-Mail-Vorlagen.
        </p>
      </div>

      <div className="border-b border-border flex gap-1 mb-6 overflow-x-auto">
        {TABS.map(t => {
          const I = t.icon;
          const isActive = tab === t.k;
          return (
            <button
              key={t.k}
              onClick={() => setTabAndUrl(t.k)}
              data-testid={`settings-tab-${t.k}`}
              className={`px-4 py-2.5 text-xs font-bold uppercase tracking-widest border-b-2 transition-colors flex items-center gap-2 -mb-px whitespace-nowrap ${
                isActive
                  ? "border-foreground text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              <I size={13} /> {t.l}
            </button>
          );
        })}
      </div>

      {ActiveComponent && <ActiveComponent />}
    </div>
  );
}
